// extracted by mini-css-extract-plugin
export default {"contentLayout":"styles_content-layout__oEPPE"};